"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _sharedVariables = require("../../shared-variables");
require("./mask.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Mask = function Mask(props) {
  var className = props.className,
    onClick = props.onClick,
    isActive = props.isActive,
    style = props.style;
  if (!isActive) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.TransitionGroup, {
    appear: true,
    component: null
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    classNames: "sb-mask-transition",
    timeout: {
      enter: parseInt(_sharedVariables.variables.defaultAnimationEntranceDuration, 10),
      exit: parseInt(_sharedVariables.variables.defaultAnimationExitDuration, 10)
    }
  }, /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-mask ".concat(className || ''),
    key: "mask",
    onClick: onClick,
    style: style
  }))));
};
Mask.displayName = 'Mask';
Mask.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  isActive: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  style: _propTypes["default"].object
} : {};
var _default = exports["default"] = Mask;